<div class="popupbg">
    <div class="reg-popcont">
        <div class="regredbar">
            <img style="margin-left: 10%;" src="../assets/images/regala1gbbanv3.png">

            <div class="regpopmsg vcenter f-white roboto-r right">
                <div class="tabcell">
                    <span class="f-bigtitle roboto-b">
                        EL REGALO CADUC&Oacute;
                    </span>
                </div>
            </div>
        </div>

        <div class="basicrow allpads roboto-r f-black f-med">
            <div class="basicrow m-top-iv m-bott-i text-center">
                <div class="basicrow roboto-m f-big">
                    Mar&iacute;a Colmenares
                </div>

                <div class="basicrow f-bmed">
                    Te hab&iacute;a enviado un regalo de 1GB de Data.
                </div>

                <div class="basicrow m-top-ii">
                    <div class="logline full"></div>
                </div>

                <div class="basicrow m-top-ii">
                    Lo sentimos mucho, su regalo de 1GB de Data <span class="roboto-b">lleg&oacute; a los 30 D&iacute;as y venci&oacute;.</span>
                </div>

                <div class="basicrow m-top-ii">
                    <a href="#" class="btns red def-i centr vcenter">
                        <span class="tabcell">
                            Ir a mi Cuenta&nbsp;&nbsp;<i class="fa fa-angle-right" aria-hidden="true"></i>
                        </span>
                    </a>
                </div>
            </div>
        </div>
    </div>
</div>